<template>
    <div class="guidance_box">
      <div class="head_box">
        <div class="head_left">
          <img class="img" src="../../static/images/logoNew.png" alt="">
          <span class="span">业务定制系统操作指引</span>
        </div>
        <el-button type="primary" @click="enterYwtFn">进入业务定制系统</el-button>
      </div>
<!--      -->
      <div class="content_box">
        <ul class="list_ul">
          <!--        1-->
          <li class="list_li">
            <p class="li_title">双方录入</p>
            <div class="li_card">
              <!--            左侧轮播-->
              <el-carousel class="carousel" trigger="click" height="450px" :autoplay="false">
                <el-carousel-item style="text-align: center" v-for="(item, index) in imgList1" :key="index">
                  <img style="max-width: 100%; height: 450px" :src="item.src" alt="">
                </el-carousel-item>
              </el-carousel>
              <!--            右侧文字-->
              <div class="card_right">
                <p class="right_title">可按需配置电子合同模板，合同模板支持单、双方录入签约信息，同时支持针对签约方身份信息核验、签署意愿认证等。</p>
                <div class="row_box">
                  <div class="row_once">
                    <div class="radio">1</div>
                    <div class="col">
                      <p class="col_p">合同模板配置：</p>
                      <span>按照业务需求配置模板，设置模板样式、录入方数量、签署方是否固定及签章、归档设置等。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">2</div>
                    <div class="col">
                      <p class="col_p">设置合同变量：</p>
                      <span>按照业务需求配置模板所需填写的变量，支持文本、数字、日期、证件号码、下拉选项、多选、表格等多种变量配置。在配置变量时需选择录入方，在发起时由选择好的录入方填写对应变量信息。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">3</div>
                    <div class="col">
                      <p class="col_p">设置签署方信息：</p>
                      <span>填写签署方信息，支持设置顺序签署、短信签署、审批流程、抄送等配置项，签署方信息支持变量填入。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">4</div>
                    <div class="col">
                      <p class="col_p">立即发起：</p>
                      <span>合同发起后，根据模板设置，由指定签约方录入对应信息，录入完成后合同正式发起，各方在指定的签约位置完成签署。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!--        2-->
          <li class="list_li">
            <p class="li_title">前置业务首页</p>
            <div class="li_card">
              <!--            左侧轮播-->
              <el-carousel class="carousel" trigger="click" height="450px" :autoplay="false">
                <el-carousel-item style="text-align: center" v-for="(item, index) in imgList2" :key="index">
                  <img style="max-width: 100%; height: 450px" :src="item.src" alt="">
                </el-carousel-item>
              </el-carousel>
              <!--            右侧文字-->
              <div class="card_right">
                <p class="right_title">可根据用户需求自定义创建前置业务首页，集业务展示、分类浏览、电子合同签署、费用支付为一体，灵活多变，操作简单。</p>
                <div class="row_box">
                  <div class="row_once">
                    <div class="radio">1</div>
                    <div class="col">
                      <p class="col_p">创建前置业务首页：</p>
                      <span>按照业务需求，创建业务首页，可按需添加合同模板、外部链接、认证链接等。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">2</div>
                    <div class="col">
                      <p class="col_p">集成业务首页：</p>
                      <span>可将业务首页链接集成至自有业务系统中，或将链接二维码放至业务页面、海报、三折页中，便于客户了解业务，快速成单。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!--        3-->
          <li class="list_li">
            <p class="li_title">批量业务模板发起</p>
            <div class="li_card">
              <!--            左侧轮播-->
              <el-carousel class="carousel" trigger="click" height="450px" :autoplay="false">
                <el-carousel-item style="text-align: center" v-for="(item, index) in imgList3" :key="index">
                  <img style="max-width: 100%; height: 450px" :src="item.src" alt="">
                </el-carousel-item>
              </el-carousel>
              <!--            右侧文字-->
              <div class="card_right">
                <p class="right_title">
                  支持业务模板批量发起，多个业务模板相同变量一次录入，全模板可用，无需重复填写，省时省力。</p>
                <div class="row_box">
                  <div class="row_once">
                    <div class="radio">1</div>
                    <div class="col">
                      <p class="col_p">创建公共变量：</p>
                      <span>点击新增创建公共变量，支持多种变量类型，一次创建，多模板可用，无需重复创建填写，省时省力。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">2</div>
                    <div class="col">
                      <p class="col_p">创建合同：</p>
                      <span>点击新增创建批量签合同模板，支持单/双方录入，支持海量变量设置及签署方设置。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">3</div>
                    <div class="col">
                      <p class="col_p">创建业务：</p>
                      <span>选择业务模板，将所选择的模板组成批量签业务</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">4</div>
                    <div class="col">
                      <p class="col_p">立即发起：</p>
                      <span>合同发起后，根据模板设置，相同变量一次录入，减少重复操作。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!--        4-->
          <li class="list_li">
            <p class="li_title">业务模板管理</p>
            <div class="li_card">
              <!--            左侧轮播-->
              <el-carousel class="carousel" trigger="click" height="450px" :autoplay="false">
                <el-carousel-item style="text-align: center" v-for="(item, index) in imgList4" :key="index">
                  <img style="max-width: 100%; height: 450px" :src="item.src" alt="">
                </el-carousel-item>
              </el-carousel>
              <!--            右侧文字-->
              <div class="card_right">
                <p class="right_title">
                  通过可视化界面即可自由搭建匹配业务流程的模板体系，像拼搭专属“业务流程图”一样，轻松将纸质流程转化为数字化模板。</p>
                <div class="row_box">
                  <div class="row_once">
                    <div class="radio">1</div>
                    <div class="col">
                      <p class="col_p">创建业务分类：</p>
                      <span>通过分类，将不同的模板进行归纳整理，同时可按分类将模板授权给不同的成员使用。</span>
                    </div>
                  </div>
                  <div class="row_once">
                    <div class="radio">2</div>
                    <div class="col">
                      <p class="col_p">业务模板管理：</p>
                      <span>支持模板的增删改查，可直接发起，也可生成签署二维码，同时支持将模板快速授权及下载。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div style="text-align: center">
          <el-button style="width: 80%" type="primary" @click="enterYwtFn">进入业务定制系统</el-button>
        </div>
      </div>
    </div>
</template>

<script>
  import image1 from '../../static/images/saasIntroduction/ywt_list_img1.png'
  import image2 from '../../static/images/saasIntroduction/ywt_list_img2.png'
  import image3 from '../../static/images/saasIntroduction/ywt_list_img3.png'
  import image4 from '../../static/images/saasIntroduction/ywt_list_img4.png'
  import image5 from '../../static/images/saasIntroduction/ywt_list_img5.png'
  import image6 from '../../static/images/saasIntroduction/ywt_list_img6.png'
  import image7 from '../../static/images/saasIntroduction/ywt_list_img7.png'
  import image8 from '../../static/images/saasIntroduction/ywt_list_img8.png'
  import {ApiMethods} from "../../assets/js/http-serve/http-methods";
  import {mapGetters} from "vuex";
  import {getCorpToken} from "../../assets/js/http-serve/corp/common";
    export default {
        name: "guidancePage",
      layout: "headandfullpage",
      data() {
          return {
            corpUserId: '',
            imgList1: [
              {name: '', src: image1},
              {name: '', src: image2},
              {name: '', src: image3},
              {name: '', src: image4},
            ],
            imgList2: [
              {name: '', src: image5},
              {name: '', src: image2},
              {name: '', src: image3},
              {name: '', src: image4},
            ],
            imgList3: [
              {name: '', src: image6},
              {name: '', src: image1},
              {name: '', src: image7},
            ],
            imgList4: [
              {name: '', src: image6},
              {name: '', src: image1},
              {name: '', src: image8},
            ],
          }
      },
      computed: {
        ...mapGetters(["allAuthUser"]),
        bindCorpUsersList () {
          return this.$store.getters.allAuthUser.bindCorpUsers;
        },
        currentAuthUser () {
          return this.$store.getters.currentAuthUser || {};
        },
      },
      mounted() {
          this.corpUserId = this.$route.query.corpUserId;
      },
      methods: {
        async enterYwtFn() {
          if (this.corpUserId) {
            try {
              //先获取成员账号的临时token，_ctToken参数可以临时设置请求token，ut还是ct来着现成有的， (在首页就要查询成员的ywt状态，又不能切换当前currentuser)
              let result = await getCorpToken(this.corpUserId);
              let res = ''
              if (+this.$route.query.status === 4) { //状态为4：主账号开通了，子账号未开通
                res = await ApiMethods.ProfileController.ywtUserActivateApplication({_ctToken: result.data});
              } else {
                res = await ApiMethods.ProfileController.ywtSystemCorpLogin({_ctToken: result.data});
              }

              if (res.code == 0) {
                window.open(this.globalConfig.domain.ywtOrigin + `/autoLogin.html?t=${res.data.t}&s=${res.data.s}&corpLoginType=1`, '_blank')
              } else {
                this.$message.error(res.description)
              }
            } catch (e) {
              console.log(e, '接口流程错误');
              this.$message.warning('请重试！')
            }
          } else {
            ApiMethods.ProfileController.ywtSystemLogin().then(res => {
              if (res.code == 0) {
                window.open(this.globalConfig.domain.ywtOrigin + `/autoLogin.html?t=${res.data.t}&s=${res.data.s}`, '_blank')
              } else {
                this.$message.error(res.description)
              }
            })
          }
        },
        //跳转ywt系统
        jumpYwtFn() {
          ApiMethods.ProfileController.ywtSystemLogin().then(res => {
            if (res.code == 0) {
              window.open(this.globalConfig.domain.ywtOrigin + `/autoLogin.html?t=${res.data.t}&s=${res.data.s}`, '_blank')
            } else {
              this.$message.error(res.description)
            }
          })
        }
      }
    }
</script>

<style scoped lang="less">
  .guidance_box {
    padding: 30px;
    .content_box {
      padding: 20px;
      .list_ul {
        .list_li {
          margin: 20px 0;
          .li_title {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 10px;
          }
          .li_card {
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            border-radius: 4px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .carousel {
              flex-shrink: 0;
              width: 68%;
            }
            .card_right {
              flex-grow: 1;
              padding: 10px;
              .right_title {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 10px;
              }
              .row_box {

                .row_once {
                  font-size: 14px;
                  display: flex;
                  justify-content: flex-start;
                  margin-bottom: 10px;
                  .radio {
                    margin-right: 5px;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 20px;
                    background-color: #ec1c1c;
                    color: #ffffff;
                    flex-shrink: 0;
                    font-size: 12px;
                  }
                  .col {
                    .col_p {
                      font-weight: bold;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .head_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .head_left {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        .img {
          max-height: 50px;
          margin-right: 20px;
        }
        .span {
          font-size: 28px;
          color: #ec1c1c;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/ywtRelated/guidancePage.vue